import type { ItemState } from './flowTypes';
import type { State, ItemDetail } from '@shopee/flow-types';

import { generateAddressKey } from './utils';

export function getItemById(
  state: State,
  itemId: number,
  itemStateSelector?: (globalState: State) => ItemState
): ItemDetail | undefined | null {
  const itemState: ItemState | undefined | null = itemStateSelector
    ? itemStateSelector(state)
    : state.item;
  if (!itemState || !itemState.items) {
    return null;
  }
  return itemState.items[itemId + ''];
}

export function getItemErrorById(
  state: State,
  itemId: number
): number | undefined | null {
  if (!state.item || !state.item.itemError) {
    return null;
  }
  return state.item.itemError[itemId + ''];
}

export const selectProduct = (itemState: ItemState, itemId: number) =>
  itemState.items[`${itemId}`];

export const selectProductShipping = (
  itemState: ItemState | undefined | null,
  itemId: number
) => {
  return itemState?.shipping_fee[`${itemId}`];
};

export function getItemApiProgress(
  state: State,
  itemId: number,
  itemStateSelector?: (globalState: State) => ItemState
) {
  const itemState: ItemState | undefined | null = itemStateSelector
    ? itemStateSelector(state)
    : state.item;

  return itemState?.itemsApiProgress[`${itemId}`];
}
export const selectProductShippingInfoV5 = (
  itemState: ItemState | undefined | null,
  itemId: number,
  modelId?: number | null,
  address?: { state: string; city: string }
) => {
  return modelId && address
    ? itemState?.shipping_info?.[`${itemId}`]?.modelLevel?.[`${modelId}`]?.[
        generateAddressKey(address)
      ]
    : itemState?.shipping_info?.[`${itemId}`];
};

export const getItemCensorIndex = (state: State, itemId: number): boolean => {
  const itemState = state.item;
  if (!itemState || !itemState.itemCensorIndex) {
    return false;
  }
  return itemState.itemCensorIndex[itemId + ''];
};
